import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from "../../../services/translate.service";
import { ModalService } from '../../../services/modal.service';
import { CommonModule, NgFor } from '@angular/common';
import { DialogButtonComponent } from '../../buttons/dialog-button.component';

@Component({
  standalone: true,
  selector: 'app-split-item-dialog',
  imports: [
    NgFor,
    CommonModule,
    DialogButtonComponent,
  ],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl w-80">
      <div class="p-6 w-full">
        <div>
          <h2 class="text-xl font-bold mb-4">{{title}}</h2>
        </div>
        <div class="mt-4 flex flex-col gap-2 items-center">
          <div class="my-4">{{getString("Hur många personer skall dela?")}}</div>
          <div *ngFor="let btn of buttons" (click)="btnClicked(btn)">
            <app-dialog-button customClass="w-52" [text]="btn.text" (onClick)="btnClicked(btn)" variant="primary"></app-dialog-button>
          </div>

          <div style="padding: 16px;margin-top: 32px;">
            <app-dialog-button customClass="w-52" [text]="getString('Avbryt')" (onClick)="close(false)" variant="default"></app-dialog-button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SplitItemDialogComponent implements OnInit {
  title!: string;
  buttons!: any[];
  private item: any;

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: {
      title: string;
      message: string;
      buttons: { action: string, text: string }[];
      item: any;
    },
    private translate: TranslateService
  ) {
    this.item = data.item;
  }

  ngOnInit(): void {
    this.title = this.getString("Dela upp") + ": " + this.item.name;
    this.buttons = [];
    this.buttons.push({ text: '2 😀😀', parts: 2 });
    this.buttons.push({ text: '3 😀😀😀', parts: 3 });
    this.buttons.push({ text: '4 😀😀😀😀', parts: 4 });
    this.buttons.push({ text: '5 😀😀😀😀😀', parts: 5 });
  }

  btnClicked(btn: any) {
    console.log("btn:", btn);
    this.modalService.close(btn);
  }

  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }

  close(value: any = false) {
    this.modalService.close(value);
  }

}
